var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"citationPushPreviewHtml"},[_c('div',{staticClass:"center_2",staticStyle:{"padding-top":"20px"}},[_c('iframe',{staticStyle:{"margin-top":"20px","width":"100%"},attrs:{"id":"iframe","src":_vm.pageUrl,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }